var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFonts = function SvgFonts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 97,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__a)",
    fillRule: "evenodd",
    d: "M2 0A1.5 1.5 0 0 0 .5 1.5v94A1.5 1.5 0 0 0 2 97h94a1.5 1.5 0 0 0 1.5-1.5v-94A1.5 1.5 0 0 0 96 0zm1.5 16.882h91V3h-91zM3.5 94V19.882h91V94zM14.853 9.94a2.11 2.11 0 1 1-4.22 0 2.11 2.11 0 0 1 4.22 0m7.865 2.11a2.11 2.11 0 1 0 0-4.22 2.11 2.11 0 0 0 0 4.22m12.086-2.11a2.11 2.11 0 1 1-4.22 0 2.11 2.11 0 0 1 4.22 0M49 8.44a1.5 1.5 0 0 0 0 3h36.257a1.5 1.5 0 1 0 0-3zM31.124 30.695v-3.872a1.5 1.5 0 0 0-1.5-1.5H18.882a1.5 1.5 0 0 0-1.5 1.5v10.743a1.5 1.5 0 0 0 1.5 1.5h3.871v35.751h-3.871a1.5 1.5 0 0 0-1.5 1.5V87.06a1.5 1.5 0 0 0 1.5 1.5h10.742a1.5 1.5 0 0 0 1.5-1.5v-3.872h35.752v3.872a1.5 1.5 0 0 0 1.5 1.5h10.742a1.5 1.5 0 0 0 1.5-1.5V76.316a1.5 1.5 0 0 0-1.5-1.5h-3.871V39.065h3.871a1.5 1.5 0 0 0 1.5-1.5V26.822a1.5 1.5 0 0 0-1.5-1.5H68.376a1.5 1.5 0 0 0-1.5 1.5v3.872zm0 49.493h35.752v-3.87a1.5 1.5 0 0 1 1.5-1.5h3.87V39.064h-3.87a1.5 1.5 0 0 1-1.5-1.5v-3.871H31.124v3.871a1.5 1.5 0 0 1-1.5 1.5h-3.87v35.751h3.87a1.5 1.5 0 0 1 1.5 1.5zm38.752-51.865v7.743h7.742v-7.743zm-49.494 7.743v-7.743h7.742v7.743zm49.494 41.751v7.743h7.742v-7.743zM20.382 85.56v-7.743h7.742v7.743zm18.113-44.924a1.5 1.5 0 0 1 1.5-1.5h18.01a1.5 1.5 0 1 1 0 3h-7.541v31.112a1.5 1.5 0 0 1-3 0V42.135h-7.47a1.5 1.5 0 0 1-1.5-1.5",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__a",
    x1: -20.286,
    x2: 107.893,
    y1: 65.821,
    y2: 65.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })))));
};
export default SvgFonts;